export const translationSolutions_en = {
  confirmDeleteFreshdeskIntegration:
    'Remove Freshdesk integration "{name}"? This cannot be undone.',
  confirmDeleteHttpIntegration: 'Remove HTTP integration "{name}"? This cannot be undone.',
  confirmDeleteShopifyCredentials: "Delete Shopify credentials? This cannot be undone.",
  confirmDeleteMagentoCredentials: "Delete Magento credentials? This cannot be undone.",
  confirmDeleteShipmondoCredentials: "Delete Shipmondo credentials? This cannot be undone.",
  confirmDeleteCommerceToolsCredentials: "Delete CommerceTools credentials? This cannot be undone.",
  confirmDeleteRaptorCredentials: "Delete Raptor credentials? This cannot be undone.",
  confirmRemoveKnowledgeBaseIndex:
    'Remove knowledge base index "{namespace}" ({indexName})? This cannot be undone.',
};
